import React, { Component } from "react";
import { connect } from "react-redux";
import MyCheckbox from "../layout/Checkbox";
import { searchAction } from "../../store/actions/searchActions";
import {
  toggleModalAction,
  addFilterValueAction,
  removeFilterValueAction,
  replaceFilterValuesAction,
  clearFilterValuesAction,
} from "../../store/actions/filtersActions";
import Collapsible from "../layout/Collapsible";

const range = (start, end) =>
  Array.from({ length: end - start + 1 }, (v, k) => k + start);

class AskIslamFilters extends Component {
  months = [
    { name: "January", number: 1 },
    { name: "February", number: 2 },
    { name: "March", number: 3 },
    { name: "April", number: 4 },
    { name: "May", number: 5 },
    { name: "June", number: 6 },
    { name: "July", number: 7 },
    { name: "August", number: 8 },
    { name: "September", number: 9 },
    { name: "October", number: 10 },
    { name: "November", number: 11 },
    { name: "December", number: 12 },
  ];

  constructor(props) {
    super(props);
    this.applyFilters = this.applyFilters.bind(this);
    this.handleYearCheckbox = this.handleYearCheckbox.bind(this);
    this.selectAllYears = this.selectAllYears.bind(this);
    this.handleMonthCheckbox = this.handleMonthCheckbox.bind(this);
    this.handleLanguageCheckbox = this.handleLanguageCheckbox.bind(this);
  }

  selectAllYears(e) {
    const yearStart = this.props.yearStart || 1984;
    const yearEnd = this.props.yearEnd || 1996;
    const yearsField = this.props.yearsField || 'years';
    if (e.target.checked) {
      this.props.replaceFilterValues(yearsField, [...range(yearStart, yearEnd)]);
    } else {
      this.props.clearFilterValues(yearsField);
    }
  }

  handleYearCheckbox(e) {
    const year = parseInt(e.target.id.split("-")[2]);
    const yearsField = this.props.yearsField || 'years';
    if (e.target.checked) {
      this.props.addFilterValue(yearsField, year);
    } else {
      this.props.removeFilterValue(yearsField, year);
    }
  }

  applyFilters() {
    this.props.perfromSearch(
      document.querySelector("#search_field").value,
      this.props.filters
    );
    this.props.toggleModal(false);
  }

  handleMonthCheckbox(e) {
    // Extract the numerical month directly from the id
    const month = parseInt(e.target.id.split("-")[2]);
    const monthsField = this.props.monthsField || 'months';
    if (e.target.checked) {
      this.props.addFilterValue(monthsField, month);
    } else {
      this.props.removeFilterValue(monthsField, month);
    }
  }

  handleLanguageCheckbox(e) {
    const language = e.target.id.split("-").pop();
    const languagesField = this.props.languagesField || 'languages';
    if (e.target.checked) {
      this.props.addFilterValue(languagesField, language);
    } else {
      this.props.removeFilterValue(languagesField, language);
    }
  }

  render() {
    const { filters } = this.props;
    const years = filters[this.props.yearsField || 'years'] || [];
    const months = filters[this.props.monthsField || 'months'] || [];
    const languages = filters[this.props.languagesField || 'languages'] || [];

    const yearRange = {
      start: this.props.yearStart || 1984,
      end: this.props.yearEnd || 1996,
    };
    const filterIdPrefix = this.props.filterIdPrefix || "askIslam";

    return (
      <div>
        {/* Years section for Ask Islam */}
        <Collapsible
          defaultExpanded={true}
          header="Years"
          preBody={
            <MyCheckbox onChange={this.selectAllYears} label="Select all" />
          }
          body={
            <div className="filters-flex">
              {[...range(yearRange.start, yearRange.end)].map(
                (year) => (
                  <div key={year} className="width-content margin-left-40p">
                    <MyCheckbox
                      checked={years.includes(year)}
                      onChange={this.handleYearCheckbox}
                      label={String(year)}
                      id={`${filterIdPrefix}-year-${year}`}
                    />
                  </div>
                )
              )}
            </div>
          }
        />

        {/* Months section for Ask Islam */}
        <Collapsible
          defaultExpanded={true}
          header="Months"
          body={
            <div className="filters-flex">
              {this.months.map((month) => (
                <div key={month.number} className="width-content margin-left-40p">
                  <MyCheckbox
                    checked={months.includes(month.number)}
                    onChange={this.handleMonthCheckbox}
                    label={month.name}
                    id={`${filterIdPrefix}-month-${month.number}`}
                  />
                </div>
              ))}
            </div>
          }
        />
        {this.props.showLanguageFilter && (
          <Collapsible
            defaultExpanded={true}
            header="Languages"
            body={
              <div className="filters-flex">
                {[
                  { value: "en", label: "English" },
                ].map((language) => (
                  <div key={language.value} className="width-content margin-left-40p">
                    <MyCheckbox
                      checked={languages.includes(language.value)}
                      onChange={this.handleLanguageCheckbox}
                      label={language.label}
                      id={`${filterIdPrefix}-language-${language.value}`}
                    />
                  </div>
                ))}
              </div>
            }
          />
        )}
        {this.props.showApplyButton !== false && <div className="apply-filters-container">
          <button
            onClick={this.applyFilters}
            className="btn apply-filters-btn margin-auto display-block"
          >
            Apply and Search
          </button>
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    perfromSearch: (term, filters) => dispatch(searchAction(term, 0, filters)),
    toggleModal: (value) => dispatch(toggleModalAction(value)),
    addFilterValue: (field, value) => dispatch(addFilterValueAction(field, value)),
    removeFilterValue: (field, value) => dispatch(removeFilterValueAction(field, value)),
    replaceFilterValues: (field, values) => dispatch(replaceFilterValuesAction(field, values)),
    clearFilterValues: (field) => dispatch(clearFilterValuesAction(field)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AskIslamFilters);
